const KENYA = {
  "Nairobi": {
    "Westlands": ["Kitisuru","Parklands","Highridge","Kangemi","Mountain View"],
    "Dagoretti North": ["Kilimani","Kawangware","Gatina","Kileleshwa","Kabiro"],
    "Dagoretti South": ["Mutu-ini","Ngando","Riruta","Uthiru","Waithaka"],
    "Langata": ["Karen","Nairobi West","Mugumu-Ini","South C","Nyayo Highrise"],
    "Kibra": ["Laini Saba","Lindi","Makina","Woodley","Sarangombe"],
    "Roysambu": ["Githurai","Kahawa West","Zimmerman","Roysambu","Clay City"],
    "Kasarani": ["Mwiki","Kasarani","Njiru","Ruai","Clay City"],
    "Embakasi East": ["Upper Savanna","Lower Savanna","Embakasi","Utawala","Mihango"],
    "Embakasi West": ["Mutuini","Ngando","Riruta","Uthiru","Waithaka"],
    "Makadara": ["Maringo","Viwandani","Harambee","Makongeni"],
    "Kamukunji": ["Pumwani","Eastleigh North","Eastleigh South","Airbase"],
    "Starehe": ["Stadium","Ngara","Pangani","Ziwani","Landimawe"],
    "Mathare": ["Hospital","Mabatini","Huruma","Ngei","Mlango Kubwa"]
  },
  "Mombasa": {
    "Changamwe": ["Port Reitz","Kipevu","Airport","Miritini","Chaani"],
    "Jomvu": ["Jomvu Kuu","Mikindani","Mivumoni"],
    "Kisauni": ["Mjambere","Junda","Bamburi","Mwakirunge","Mtopanga"],
    "Nyali": ["Frere Town","Ziwa La Ngombe","Mkomani","Kongowea","Kadzandani"],
    "Likoni": ["Mtongwe","Shika Adabu","Bofu","Likoni","Timbwani"],
    "Mvita": ["Mji wa Kale","Tudor","Tononoka","Shimanzi","Majengo"]
  },
  "Kisumu": {
    "Kisumu East": ["Kajulu","Kolwa East","Manyatta B","Nyalenda A","Kolwa Central"],
    "Kisumu West": ["South West Kisumu","Central Kisumu","Kisumu North","West Kisumu"],
    "Kisumu Central": ["Railways","Migosi","Shaurimoyo","Market Milimani","Kondele"],
    "Seme": ["West Seme","Central Seme","East Seme","North Seme"],
    "Nyando": ["East Kano","Awasi","Ahero","Kabonyo","Kobura"],
    "Muhoroni": ["Miwani","Ombeyi","Masogo","Chemelil","Muhoroni"],
    "Nyakach": ["South Nyakach","Central Nyakach","West Nyakach","Kasgunga"]
  },
  "Nakuru": {
    "Nakuru Town East": ["Biashara","Kivumbini","Flamingo","Menengai","Nakuru East"],
    "Nakuru Town West": ["Barut","London","Kaptembwo","Kapkures","Rhoda"],
    "Njoro": ["Njoro","Mau Narok","Mauche","Kihingo","Nessuit"],
    "Molo": ["Molo","Turi","Marioshoni","Elburgon","Elementaita"],
    "Rongai": ["Menengai West","Soin","Visoi","Mosop","Solai"],
    "Naivasha": ["Naivasha East","Viwandani","Biashara","Hells Gate","Lake View"],
    "Gilgil": ["Gilgil","Malewa West","Kariuki","Mbaruk","Karati"],
    "Bahati": ["Bahati","Lanet","Kabatini","Kiamaina","Dundori"],
    "Subukia": ["Subukia","Waseges","Kabazi"]
  },
  "Kiambu": {
    "Thika Town": ["Township","Kamenu","Hospital","Gatuanyaga","Ngoliba"],
    "Ruiru": ["Gitothua","Biashara","Kirera","Mwiki","Mwihoko"],
    "Juja": ["Murera","Tower","Kalimoni","Witeithie","Juja Farm"],
    "Kikuyu": ["Karai","Nachu","Sigona","Kikuyu","Kinoo"],
    "Limuru": ["Biashara","Ndeiya","Limuru Central","Ngecha Tigoni","Kamirithu"],
    "Githunguri": ["Githunguri","Githiga","Ikinu","Ngewa","Komothai"],
    "Kiambu": ["Kiambu Town","Tinganga","Ndumberi","Riabai","Township"],
    "Lari": ["Kijabe","Nyanduma","Kirenga","Kinale"],
    "Gatundu South": ["Gatundu","Kiganjo","Ndarugu","Ngenda"],
    "Gatundu North": ["Gachoka","Kariara","Igura","Githobokoni","Chania"]
  },
  "Kericho": {
    "Ainamoi": ["Kipchebor","Kabianga","Kapsoit","Chepseon","Ainamoi"],
    "Belgut": ["Waldai","Kaplelartet","Tenges","Cheboin","Fort Ternan"],
    "Bureti": ["Tebesonik","Chemosot","Litein","Cheplanget","Kapkatet"],
    "Kipkelion East": ["Londiani","Kedowa","Chepseon","Roret","Kipkelion"],
    "Kipkelion West": ["Kunyak","Chilchila","Sorget","Kebeneti","Sigor"],
    "Soin/Sigowet": ["Sigowet","Kabianga","Rongena","Soin"]
  },
  "Kakamega": {
    "Lugari": ["Mautuma","Lugari","Lumakanda","Chekalini","Chevaywa"],
    "Likuyani": ["Nzoia","Likuyani","Sango","Kongoni","Sinoko"],
    "Malava": ["Central Malava","Chemuche","Shirugu","South Kabras"],
    "Lurambi": ["Sheywe","Mahiakalo","Ikolomani","Isukha North"],
    "Mumias West": ["Mumias","Etenje","Musanda","Koyonzo"],
    "Mumias East": ["Lusheya","Chesamisi","Mumias East","Malaha"],
    "Matungu": ["Koyonzo","Kholera","Mayoni","Namamali","Matungu"],
    "Butere": ["Marama West","Marama Central","Marama East","Butere"],
    "Shinyalu": ["Idakho South","Idakho East","Idakho Central","Idakho North"]
  },
  "Meru": {
    "Igembe South": ["Maua","Kiegoi","Akachiu","Kanuni"],
    "Igembe Central": ["Njia","Uri","Igembe East"],
    "Tigania West": ["Mbeu","Nkomo","Mikinduri","Kiguchwa","Athwana"],
    "Tigania East": ["Karama","Mitunguu","Igoji West","Igoji East"],
    "North Imenti": ["Municipality","Ntima East","Ntima West","Nyaki West","Nyaki East"],
    "Central Imenti": ["Township","Nkuene","Mwanganthia","Abogeta East"],
    "South Imenti": ["Mithi","Kibirichia","Igoji East","Igoji West"],
    "Buuri": ["Timau","Kisima","Kiirua","Ruiri"]
  },
  "Machakos": {
    "Masinga": ["Masinga Central","Ekalakala","Mwania","Kivaa"],
    "Yatta": ["Ndalani","Matuu","Kithimani","Ikombe","Katangi"],
    "Kangundo": ["Kangundo North","Kangundo Central","Kangundo East","Kangundo West"],
    "Kathiani": ["Mitaboni","Kathiani Central","Upper Kaewa","Lower Kaewa"],
    "Mavoko": ["Athi River","Kinanie","Muthwani","Syokimau"],
    "Machakos Town": ["Machakos Central","Mutituni","Muvuti","Kalama"],
    "Mwala": ["Mbuni","Makutano","Masii","Muthetheni","Wamunyu"]
  },
  "Uasin Gishu": {
    "Soy": ["Mois Bridge","Kipsomba","Soy","Ziwa","Kuinet"],
    "Turbo": ["Tapsagoi","Kamagut","Huruma","Ngenyilel","Turbo"],
    "Moiben": ["Tembelio","Sergoit","Karuna","Moiben","Kuinet"],
    "Ainabkoi": ["Ainabkoi","Kaptagat","Kapsoya"],
    "Kapseret": ["Simat","Megun","Langas","Racecourse"],
    "Kesses": ["Tarakwa","Ngeny","Sugoi","Kamagut","Burnt Forest"]
  },
  "Trans Nzoia": {
    "Kwanza": ["Kwanza","Keiyo","Bidii","Matisi"],
    "Endebess": ["Endebess","Chepchoina","Motosiet"],
    "Saboti": ["Kinyoro","Matisi","Tuwani","Saboti","Machewa"],
    "Kiminini": ["Kiminini","Sikhendu","North Kiminini","Nabiswa"],
    "Cherangany": ["Cherangany","Sinyerere","Kaplamai","Makutano"]
  },
  "Bungoma": {
    "Mount Elgon": ["Cheptais","Chesikaki","Chepyuk","Kapkateny","Kaptama"],
    "Sirisia": ["Namwela","Malakisi","Lwandanyi"],
    "Kabuchai": ["Kabuchai","West Kabuchai","Naitiri","Mukuyuni"],
    "Bumula": ["Bumula","Khasoko","Kabula","Kimaeti"],
    "Kanduyi": ["Musikoma","East Sangalo","Township","Khalaba"],
    "Webuye East": ["Maraka","Lugulu","Ndivisi","Mihuu"],
    "Webuye West": ["Sitikho","Matulo","Bokoli"],
    "Kimilili": ["Kimilili","Maeni","Kamukuywa","Kibingei"],
    "Tongaren": ["Naitiri","Milima","Ndalu","Tongaren","Mbakalo"]
  },
  "Kisii": {
    "Bonchari": ["Bomariba","Bogiakumu","Riana","Bonchari"],
    "South Mugirango": ["Boikanga","Bokeira","Magwagwa","Ekerenyo"],
    "Bobasi": ["Boitangare","Moticho","Gakero","Nyacheki"],
    "Nyaribari Masaba": ["Gesusu","Ichuni","Nyamasibi","Masimba"],
    "Nyaribari Chache": ["Kegati","Bobaracho","Kisii Central","Keumbu"],
    "Kitutu Chache North": ["Kegogi","Monyerero","Itierio","Kiamokama"],
    "Kitutu Chache South": ["Bogeka","Nyakoe","Kitutu Central"]
  },
  "Homa Bay": {
    "Kasipul": ["West Kasipul","Central Kasipul","Suba North","East Kasipul"],
    "Karachuonyo": ["North Karachuonyo","West Karachuonyo","Central Karachuonyo"],
    "Rangwe": ["East Gem","West Gem","Kagan","Kochia"],
    "Homa Bay Town": ["Homa Bay Central","Homa Bay Arujo","Homa Bay West"],
    "Ndhiwa": ["Kwabwai","Kanyadoto","Kanyikela","Pala"],
    "Mbita": ["Rusinga Island","Mfangano Island","Mbita","Suba South"],
    "Suba South": ["Gwassi South","Gwassi North","Kaksingri West"]
  },
  "Migori": {
    "Rongo": ["North Kadem","Macalder","Kuria East","Isibania","Tagare"],
    "Awendo": ["North Sakwa","South Sakwa","West Sakwa","Central Sakwa"],
    "Suna East": ["Wiga","Wasweta II","Kakrao","Kwa"],
    "Suna West": ["Wath Onger","Wasimbete","God Jope","Suna Central"],
    "Kuria East": ["Gokeharaka","Ntimaru West","Ntimaru East","Nyabasi East"],
    "Kuria West": ["Bukira East","Bukira Central","Isibania","Tagare"],
    "Uriri": ["West Kanyamkago","North Kanyamkago","Central Kanyamkago"],
    "Nyatike": ["Kachieng","Kanyasa","North Kadem","Got Kachola"]
  },
  "Siaya": {
    "Ugenya": ["West Ugenya","Ukwala","North Ugenya","East Ugenya"],
    "Alego Usonga": ["Central Alego","Siaya Township","North Alego","West Alego"],
    "Gem": ["North Gem","West Gem","Central Gem","East Gem","South Gem"],
    "Bondo": ["Usigu","North Uyoma","East Uyoma","West Uyoma"],
    "Rarieda": ["East Asembo","West Asembo","North Uyoma","South Uyoma"]
  },
  "Embu": {
    "Manyatta": ["Ruguru","Gaturi North","Gaturi South","Kamiu","Nembure"],
    "Runyenjes": ["Kyeni North","Kyeni Central","Kyeni South","Muminji"],
    "Mbeere South": ["Mbeti North","Mavuria","Kiambere","Mbeti South"],
    "Mbeere North": ["Evurore","Mwea","Makima","Nthawa"]
  },
  "Nyeri": {
    "Tetu": ["Dedan Kimathi","Wamagana","Aguthi-Gaaki"],
    "Kieni": ["Mweiga","Naromoru","Mwiyogo","Mukurweini"],
    "Mathira East": ["Ruguru","Karatina Town","Konyu","Kagoini"],
    "Mathira West": ["Iriaini","Gatitu","Kirimukuyu"],
    "Othaya": ["Mahiga","Iria-ini","Chinga","Karima"],
    "Mukurweini": ["Mukurweini East","Mukurweini West","Gikondi","Rugi"],
    "Nyeri Town": ["Rware","Gatitu","Kangemi","Mahiga"]
  },
  "Nyandarua": {
    "Kinangop": ["Gathara","North Kinangop","Murungaru","Njabini","Engineer"],
    "Kipipiri": ["Wanjohi","Kipipiri","Geta","Githioro"],
    "Ol Kalou": ["Karau","Kanjuiri Ridge","Mirangine","Kariara","Gathanji"],
    "Ndaragwa": ["Leshau","Kiriita","Central","Shamata"]
  },
  "Laikipia": {
    "Laikipia West": ["Rumuruti","Githiga","Igwamiti","Salama"],
    "Laikipia North": ["Mukogondo East","Mukogondo West","Sosian"],
    "Laikipia East": ["Ngobit","Tigithi","Thingithu","Nanyuki"],
    "Nyahururu": ["Nyahururu","Kihara","Ol Joro Orok"]
  },
  "Baringo": {
    "Baringo Central": ["Kabartonjo","Sacho","Tenges","Ewalel","Kapropita"],
    "Baringo North": ["Barwessa","Kabarnet","Saimo"],
    "Eldama Ravine": ["Ravine","Maji Mazuri","Koibatek","Lembus"],
    "Mogotio": ["Mogotio","Emining","Kisanana"],
    "Tiaty": ["Tirioko","Kolowa","Ribkwo","Silale"]
  },
  "Kajiado": {
    "Kajiado North": ["Olmotiany","Nkaimurunya","Township","Ongata Rongai"],
    "Kajiado Central": ["Purko","Dalalekutuk","Mesheriani"],
    "Kajiado East": ["Mosiro","Iloodokilani","Magadi","Shompole"],
    "Kajiado West": ["Keekonyokie","Nentale","Entonet"],
    "Kajiado South": ["Oldonyiro","Amboseli","Kimana","Loitokitok"]
  },
  "Narok": {
    "Kilgoris": ["Keyian","Angata Barikoi","Shankoe","Lolgorian"],
    "Narok North": ["Narok Town","Naikarra","Olpusimoru","Olokurto"],
    "Narok South": ["Majimoto","Olchoro Onyore","Ol Kiombo"],
    "Narok West": ["Mara","Siana","Nkoilale"]
  },
  "Bomet": {
    "Bomet Central": ["Bomet East","Bomet Central","Silibwet"],
    "Bomet East": ["Kembu","Longisa","Kipreres","Chemaner"],
    "Chepalungu": ["Sigor","Kongasis","Ndaraweta","Siongiroi"],
    "Konoin": ["Mogogosiek","Chepchabas","Embomos","Merigi"],
    "Sotik": ["Ndanai","Chemagel","Kipsonoi","Mutarakwa"]
  },
  "Nandi": {
    "Chesumei": ["Lelmokwo","Chemundu","Kosirai","Nandi Hills"],
    "Emgwen": ["Kapsabet","Motosiet","Nandi Hills","Kilibwoni"],
    "Mosop": ["Kabiyet","Ndalat","Kabwareng","Kosirai"],
    "Aldai": ["Serem","Kaptumo","Ol Lessos"],
    "Tinderet": ["Tinderet","Chemelil","Songhor","Kunyak"]
  },
  "Vihiga": {
    "Vihiga": ["Vihiga","Luanda","Emabungo","North Maragoli"],
    "Sabatia": ["Wodanga","Sabatia","Chavakali","North Maragoli"],
    "Hamisi": ["Shiru","Gisambai","Shamakhokho","Banja"],
    "Emuhaya": ["North East Bunyore","Central Bunyore","West Bunyore"]
  },
  "Busia": {
    "Teso North": ["Malaba North","Malaba South","Ang'urai South","Ang'urai North"],
    "Teso South": ["Amukura West","Amukura East","Amukura Central","Chakol"],
    "Nambale": ["Nambale Township","Bukhayo North","Bukhayo Central"],
    "Matayos": ["South Sakwa","Bunyala Central","Bunyala East","Bunyala West"],
    "Butula": ["Elugulu","Sifuyo","Bunyala North","Butula"],
    "Funyula": ["Nambuku","Wasenje","Mukhweya","Funyula"]
  },
  "Nyamira": {
    "Kitutu Masaba": ["Rigoma","Gachuba","Gesima","Ichuni"],
    "West Mugirango": ["Bosamaro","Bonyamatuta","Township","Bogetenga"],
    "North Mugirango": ["Bombaba Borabu","Boochi","Bokeira","Magwagwa"],
    "Borabu": ["Metembe","Borabu","Masige West","Masige East"]
  },
  "Elgeyo Marakwet": {
    "Marakwet East": ["Kapyego","Sambirir","Endo","Embobut"],
    "Marakwet West": ["Lelan","Sengwer","Cherangany","Moiben"],
    "Keiyo North": ["Emsoo","Kamariny","Kapchemutwa","Tosion"],
    "Keiyo South": ["Kaptarakwa","Chepkorio","Soy North","Metkei"]
  },
  "West Pokot": {
    "Kacheliba": ["Kacheliba","Kodich","Kapchok","Kasei","Sook"],
    "Pokot South": ["Sook","Tapach","Sekerr","Alale","Chepareria"],
    "West Pokot": ["Kapenguria","Mnagei","Siyoi","Endugh"],
    "Sigor": ["Masool","Lomut","Weiwei","Lelan","Kasei"]
  },
  "Samburu": {
    "Samburu West": ["Suguta Marmar","Maralal","Loosuk","El Barta"],
    "Samburu North": ["Nachola","Ndoto","Namarei","Angata Nanyokie"],
    "Samburu East": ["Wamba West","Wamba East","Wamba North","Loglogo"]
  },
  "Isiolo": {
    "Isiolo North": ["Wabera","Chari","Burat","Oldonyiro","Ngare Mara"],
    "Isiolo South": ["Garbatulla","Kinna","Sericho"]
  },
  "Marsabit": {
    "Moyale": ["Moyale Township","Butiye","Sololo","Heillu"],
    "North Horr": ["Dukana","Maikona","Turbi","North Horr","Illeret"],
    "Saku": ["Kargi","Marsabit Central","Loiyangalani"],
    "Laisamis": ["Laisamis","Logologo","Korr","Merille"]
  },
  "Mandera": {
    "Mandera West": ["Takaba South","Takaba","Lagsure","Dandu"],
    "Banissa": ["Banissa","Dertu","Boji","Guticha"],
    "Mandera North": ["Ashabito","Morothile","Rhamu"],
    "Mandera South": ["Wajir Bor","Gold Jefti","Lafey"],
    "Mandera East": ["Libehia","Khalalio","Neboi","Arabia"]
  },
  "Wajir": {
    "Wajir North": ["Gurar","Bute","Korondille","Griftu"],
    "Wajir East": ["Habaswein","Lagdera","Benane","Kotulo"],
    "Tarbaj": ["Tarbaj","Wargadud","Sarman"],
    "Wajir West": ["Ganyure","Township","Barwago","Hadado"],
    "Eldas": ["Eldas","Della","Lafey","Wajir Bor"],
    "Wajir South": ["Ademasajide","Burder","Dadaab","Abakaile"]
  },
  "Garissa": {
    "Garissa Township": ["Waberi","Galbet","Township","Iftin"],
    "Balambala": ["Balambala","Danyere","Jarajila","Saka"],
    "Lagdera": ["Modogashe","Benane","Goreale","Maalimin"],
    "Dadaab": ["Dadaab","Labasigale","Damajale","Liboi"],
    "Fafi": ["Bura","Bangale","Sala","Nanighi"],
    "Ijara": ["Sangailu","Ijara","Masalani","Hulugho"]
  },
  "Tana River": {
    "Garsen": ["Kipini East","Garsen South","Kipini West","Garsen North"],
    "Galole": ["Wayu","Chewele","Hirimani","Makere"],
    "Bura": ["Chewele","Tana North","Tana Delta","Madogo"]
  },
  "Lamu": {
    "Lamu East": ["Faza","Kiunga","Basuba"],
    "Lamu West": ["Shela","Mkomani","Hindi","Witu"]
  },
  "Taita Taveta": {
    "Taveta": ["Chala","Mahoo","Bomani","Mboghoni","Mata"],
    "Wundanyi": ["Wundanyi","Werugha","Wumingu","Mwanda"],
    "Mwatate": ["Ronge","Mwatate","Bura","Chawia"],
    "Voi": ["Makindu","Wusi","Mbololo","Sagala","Kaloleni"]
  },
  "Kwale": {
    "Msambweni": ["Gombato Bongwe","Ukunda","Kinondo","Ramisi"],
    "Lunga Lunga": ["Pongwe","Dzombo","Mwereni","Vanga"],
    "Matuga": ["Tsimba Golini","Waa","Tiwi","Mkongani"],
    "Kinango": ["Ndavaya","Puma","Kinango","Mackinnon Road"]
  },
  "Kilifi": {
    "Kilifi North": ["Tezo","Sokoni","Kibarani","Dabaso","Matsangoni"],
    "Kilifi South": ["Junju","Mwarakaya","Shimo La Tewa","Chasimba"],
    "Kaloleni": ["Mariakani","Kayafungo","Kaloleni","Ruruma"],
    "Rabai": ["Rabai","Mwawesa","Ruruma","Kambe"],
    "Ganze": ["Ganze","Bamba","Jaribuni","Sokoke"],
    "Malindi": ["Jilore","Kakuyuni","Ganda","Malindi Town","Shella"],
    "Magarini": ["Marafa","Magarini","Gongoni","Adu","Garashi"]
  },
  "Turkana": {
    "Turkana North": ["Lapur","Kaeris","Lake Zone","Lokitanyala"],
    "Turkana West": ["Kakuma","Lopur","Letea","Kalobeyei"],
    "Turkana Central": ["Township","Kerio Delta","Lobei","Lodwar"],
    "Loima": ["Kotaruk","Turkwel","Loima","Lokiriama"],
    "Turkana South": ["Kerio Delta","Lokichar","Nakwamoru"],
    "Turkana East": ["Kapedo","Katilu","Lobokat","Nanam"]
  },
  "Kirinyaga": {
    "Mwea": ["Mutithi","Kangai","Wamumu","Nyangati","Gathigiriri"],
    "Gichugu": ["Kabare","Baragwi","Ndia","Mugirango"],
    "Ndia": ["Mukure","Kibingoti","Kiine","Karumandi"],
    "Kirinyaga Central": ["Inoi","Kariti","Mutira","Kerugoya"]
  },
  "Muranga": {
    "Kandara": ["Ng'araria","Muruka","Kagundu-Ini","Gaichanjiru","Ithiru"],
    "Gatanga": ["Ithanga","Kakuzi","Mugumo-Ini","Kihumbu-Ini"],
    "Kiharu": ["Wangu","Mugoiri","Mbiri","Township","Kiharu"],
    "Kigumo": ["Kigumo","Kangari","Muthithi","Kinyona"],
    "Maragwa": ["Kimorori","Makuyu","Kambiti","Kamahuha"],
    "Kangema": ["Rwathia","Muguru","Kanyenya-Ini","Kangema"]
  },
  "Tharaka Nithi": {
    "Maara": ["Igambangombe","Nthangaitha","Thuura","Maara"],
    "Chuka": ["Chuka","Igambangombe","Mariani"],
    "Tharaka": ["Tharaka North","Tharaka South","Nkondi","Gatunga"]
  },
  "Kitui": {
    "Mwingi North": ["Ngomeni","Kyuso","Mumoni","Tseikuru"],
    "Mwingi West": ["Kyuso","Mumoni","Tseikuru"],
    "Mwingi Central": ["Kivou","Nguni","Nuu","Mui"],
    "Kitui West": ["Mutonguni","Kauwi","Matiny","Mulu"],
    "Kitui Rural": ["Kisasi","Mbitini","Kwavonza","Kanyangi"],
    "Kitui Central": ["Mulundi","Kyangwithya West","Miambani","Township"],
    "Kitui East": ["Zombe","Chuluni","Nzambani","Mutito"],
    "Kitui South": ["Ikanga","Mutomo","Mutha","Ikutha"]
  },
  "Makueni": {
    "Mbooni": ["Tulimani","Mbooni","Kithungo","Kisau"],
    "Kilome": ["Kasikeu","Mukaa","Kiima Kimwe"],
    "Kaiti": ["Kilungu","Ilima","Kalamba","Nguumo"],
    "Makueni": ["Wote","Muvau","Mavindini","Kitise"],
    "Kibwezi West": ["Makindu","Kikumbulyu North","Kikumbulyu South","Nguu"],
    "Kibwezi East": ["Kibwezi","Masongaleni","Mtito Andei","Thange"]
  }
};

export default KENYA;
